// import { FlowPageTitle } from "melco-ui";
import { ValidateForm } from "../../components/validate/ValidateForm";
//import { useTranslation } from "react-i18next";

const Validate = () => {

  //const { t } = useTranslation()

  return (

    <>
      {/* <FlowPageTitle>{t("loginpage.title")}</FlowPageTitle> */}
      <ValidateForm />
    </>

  );
};

export default Validate;
